<ion-content [fullscreen]="true" class="page-content" color="light">
  <generic-table data-guide="history" [hidden]="guide.historyExampleVisible()" style="width: 100%; height: 100%" [tableColumns]="tableColumns" [data]="tableData"
    [config]="tableConfigParams" [isLoading]="isDataLoading" (onOptionAction)="onOptionAction($event)"
    (onFilterSelection)="onFilterSelection($any($event))" (onCtaAction)="onCtaAction($event)"></generic-table>
  @defer (when guide.historyExampleVisible()) {
    @if (guide.historyExampleVisible()) { <app-history-tutorial-example></app-history-tutorial-example> }
  }
</ion-content>
